import { __decorate, __extends } from "tslib";
import AvalonGTView from '@/utils/libs/BaseView';
import { Options } from 'vue-class-component';
import { PageService } from '@/views/copy/taskcenter/import';
import NavPanel from '@/components/common/NavPanel.vue';
import taskImgs from './imgs';
var HuanxunTaskCenter = /** @class */ (function (_super) {
    __extends(HuanxunTaskCenter, _super);
    function HuanxunTaskCenter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.taskList = [];
        _this.loading = false;
        _this.taskData = {};
        _this.title = '';
        _this.navBg = 'transparent';
        _this.scrollEl = null;
        _this.NAV_BG_THRESHOLD = 60;
        _this.onContentScroll = function () {
            if (!_this.scrollEl)
                return;
            var top = _this.scrollEl.scrollTop || 0;
            _this.navBg = top > _this.NAV_BG_THRESHOLD ? '#fff' : 'transparent';
        };
        return _this;
    }
    Object.defineProperty(HuanxunTaskCenter.prototype, "heroBg", {
        get: function () {
            return this.taskData.sex == 2 ? taskImgs.bgCash : taskImgs.bgDiamond;
        },
        enumerable: false,
        configurable: true
    });
    HuanxunTaskCenter.prototype.created = function () {
        var _this = this;
        window['doReloadData'] = function () {
            _this.doReloadData();
        };
        this.loading = true;
        this.getTask();
    };
    HuanxunTaskCenter.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            var root = _this.$refs.navPanelRef && _this.$refs.navPanelRef.$el;
            var el = root && root.querySelector ? root.querySelector('.nav-content') : null;
            if (!el)
                return;
            _this.scrollEl = el;
            el.addEventListener('scroll', _this.onContentScroll, { passive: true });
        });
    };
    HuanxunTaskCenter.prototype.unmounted = function () {
        if (this.scrollEl) {
            this.scrollEl.removeEventListener('scroll', this.onContentScroll);
            this.scrollEl = null;
        }
    };
    HuanxunTaskCenter.prototype.getTask = function () {
        var _this = this;
        this.taskList = [];
        PageService.getTaskList({})
            .then(function (data) {
            _this.taskData = data;
            _this.taskData.img = data.sex == 2 ? 1 : 2;
            _this.loading = false;
            _this.title = data.sex == 2 ? '赚现金' : '赚钻石';
            if (data.rookie && data.rookie.length != 0) {
                _this.taskList.push({
                    title: '新手任务',
                    children: data.rookie,
                });
            }
            if (data.daily && data.daily.length != 0) {
                _this.taskList.push({
                    title: '每日任务',
                    children: data.daily,
                });
            }
        })
            .catch(function () {
            _this.loading = false;
        });
    };
    HuanxunTaskCenter.prototype.rewardIcon = function (subItem) {
        switch (subItem.unit) {
            case '钻石':
                return taskImgs.iconDiamond;
            case '元':
                return taskImgs.iconGold;
            default:
                return subItem.icon || '';
        }
    };
    HuanxunTaskCenter.prototype.finishTask = function (row) {
        if (row.uri.indexOf('tata:') == -1) {
            var params = {
                navH: this.awlGlobalState.urlInitParams.navH,
                statusH: this.awlGlobalState.urlInitParams.statusH,
                version: this.awlGlobalState.urlInitParams.version,
                token: this.awlGlobalState.urlInitParams.token,
            };
            this.$router.push({
                path: row.uri,
                query: params,
            });
        }
        else {
            var params = {
                route: row.uri,
                action: 0,
            };
            this.awlGlobalConfig.messageHandlers(params);
        }
    };
    HuanxunTaskCenter.prototype.doReloadData = function () {
        this.taskList = [];
        this.getTask();
    };
    HuanxunTaskCenter = __decorate([
        Options({
            name: 'HuanxunTaskCenter',
            components: { NavPanel: NavPanel },
        })
    ], HuanxunTaskCenter);
    return HuanxunTaskCenter;
}(AvalonGTView.BaseView));
export default HuanxunTaskCenter;
